import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=335ebd6c&scoped=true&"
import script from "./BaseChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseChip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=335ebd6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ebd6c",
  null
  
)

export default component.exports